import { Injectable, effect, inject } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { LocalizationService } from './localization.service';

@Injectable()
export class LocalizedPaginatorIntl extends MatPaginatorIntl {
  private readonly localization = inject(LocalizationService);

  constructor() {
    super();
    effect(() => {
      this.localization.language();
      this.updateLabels();
      this.changes.next();
    });
  }

  override getRangeLabel = (page: number, pageSize: number, length: number): string => {
    if (length === 0 || pageSize === 0) {
      return `0 ${this.t('paginator.of', 'of')} ${length}`;
    }
    const startIndex = page * pageSize;
    const endIndex = Math.min(startIndex + pageSize, length);
    return `${startIndex + 1} - ${endIndex} ${this.t('paginator.of', 'of')} ${length}`;
  };

  private updateLabels(): void {
    this.itemsPerPageLabel = this.t('paginator.itemsPerPage', 'Items per page');
    this.nextPageLabel = this.t('paginator.nextPage', 'Next page');
    this.previousPageLabel = this.t('paginator.previousPage', 'Previous page');
    this.firstPageLabel = this.t('paginator.firstPage', 'First page');
    this.lastPageLabel = this.t('paginator.lastPage', 'Last page');
  }

  private t(key: string, fallback: string): string {
    const translated = this.localization.translate(key);
    return translated === key ? fallback : translated;
  }
}
